<template>
  <form @submit.prevent="onSubmit">
    <div class="space-y-8">
      <h6 class="uppercase text-muted">Change Password</h6>

      <!--
        User old password
      -->
      <ValidationProvider
        name="password"
        vid="password"
        rules="required"
        v-slot="{ errors, failed }"
        slim
      >
        <BaseFormGroup class="w-full">
          <BaseFormLabel> Current * </BaseFormLabel>
          <BaseFormInput
            type="password"
            v-model="password"
            :disabled="submitting"
            :invalid="failed"
            v-select
          />
          <BaseFormInlineMessage v-if="failed" danger>
            {{ errors[0] }}
          </BaseFormInlineMessage>
        </BaseFormGroup>
      </ValidationProvider>

      <!--
        User new password
      -->
      <ValidationProvider
        name="new password"
        vid="newPassword"
        rules="required|confirmed:newPasswordConfirmation"
        v-slot="{ errors, failed }"
        slim
      >
        <BaseFormGroup class="w-full">
          <BaseFormLabel> New * </BaseFormLabel>
          <BaseFormInput
            type="password"
            v-model="newPassword"
            :disabled="submitting"
            :invalid="failed"
          />
          <BaseFormInlineMessage v-if="failed" danger>
            {{ errors[0] }}
          </BaseFormInlineMessage>
        </BaseFormGroup>
      </ValidationProvider>

      <!--
        User new password confirmation
      -->
      <ValidationProvider
        name="confirmation"
        vid="newPasswordConfirmation"
        rules="required"
        v-slot="{ errors, failed }"
        slim
      >
        <BaseFormGroup class="w-full">
          <BaseFormLabel> Confirm new password * </BaseFormLabel>
          <BaseFormInput
            type="password"
            v-model="newPasswordConfirmation"
            :disabled="submitting"
            :invalid="failed"
          />
          <BaseFormInlineMessage v-if="failed" danger>
            {{ errors[0] }}
          </BaseFormInlineMessage>
        </BaseFormGroup>
      </ValidationProvider>
    </div>

    <div>
      <BaseButton type="submit" primary :disabled="submitting"> Update </BaseButton>
    </div>
  </form>
</template>

<script>
export default {
  name: 'SecurityForm',
  props: {
    submitting: Boolean,
  },
  data() {
    return {
      password: '',
      newPassword: '',
      newPasswordConfirmation: '',
    };
  },
  methods: {
    onSubmit() {
      const { password, newPassword, newPasswordConfirmation } = this;
      this.$emit('submit', {
        password,
        newPassword,
        newPassword_confirmation: newPasswordConfirmation,
      });
    },
  },
};
</script>
